/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Add, Remove } from "@material-ui/icons";
import { Typography, Button } from "@material-ui/core";
import parse from "html-react-parser";
import { Skeleton } from "@material-ui/lab";
import { Icons } from "../../components";
import DetailLoker from "./DetailLoker";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 1047px) {
    & #center1047 {
      justify-content: center !important;
    }
  }
`;

const StyledItem = styled.div<{ active: boolean }>`
  width: 100%;
  padding: 8px 0;
  padding-right: 32px;
  border-bottom: ${({ active }) => (active ? "none" : "1px solid #bbbb")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  ${(props) =>
    props.active &&
    css`
      & h6 {
        color: #e3232a;
        font-weight: 600;
      }
    `}

  & div p {
    color: ${({ active, theme }) =>
      active ? theme.colors.main : theme.colors.text.main};
  }
  & div > p:hover {
    color: #e3232a;
  }
`;

const StyledItemLeft = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const StyledCard = styled.div`
  text-decoration: none;
  display: block;
  width: 100%;
  padding-left: 42px;
  padding-right: 24px;
`;

const StyledItemCard = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border: 1px solid #e0e0e0;
  margin-bottom: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #eaeaea;
  }
`;

const StyledDescCard = styled.div`
  width: 70%;
  &:hover p:first-child {
    color: #e3232a;
  }
`;

const StyledAddressCard = styled.div`
  flex: 1;
  text-align: right;
`;

const StyledNextCard = styled.div`
  padding-left: 1rem;
`;

const Loker = ({ isId }: any) => {
  const [loadingState, setLoadingState] = useState(true);
  const [activeState, setActiveState] = useState("");
  const [dataLokerState, setDataLokerState] = useState<any>(null);
  const [detailLokerState, setDetailLokerState] = useState(false);
  const [detailDataLokerState, setDetailDataLokerState] = useState({
    id: "",
    title_id: "",
    title_en: "",
    sub_title_id: "",
    sub_title_en: "",
    place: "",
    contract: "",
    content_id: "",
    content_en: "",
  });
  const [searchDataState, setSearchDataState] = useState<any>(null);
  const [searchState, setSearchState] = useState<any>({
    job: "",
    location: "",
  });

  const getData = async () => {
    try {
      const res: any = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content?type=7`
      );
      const resJson = await res.json();
      setDataLokerState(resJson.data.rows);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  const formatDataLoker: any = (searchDataState || dataLokerState)?.reduce(
    (acc: any, d: any) => {
      const found = acc.find(
        (a: any) =>
          (isId ? a.title_id : a.title_en) === (isId ? d.title_id : d.title_en)
      );
      const value = {
        id: d.id,
        sub_title_id: d.sub_title_id,
        sub_title_en: d.sub_title_en,
        place: d.place,
        contract: d.contract,
        content_id: d.content_id,
        content_en: d.content_en,
      };
      if (!found) {
        acc.push({
          title_id: d.title_id,
          title_en: d.title_en,
          data: [value],
        });
      } else {
        found.data.push(value);
      }
      return acc;
    },
    []
  );

  return (
    <>
      {detailLokerState ? (
        <DetailLoker
          isId={isId}
          dataLoker={detailDataLokerState}
          onHandleBack={() => setDetailLokerState(false)}
        />
      ) : (
        <StyledContent>
          <StyledItemList>
            <div
              id="center1047"
              style={{
                backgroundColor: "#e3232a",
                padding: "12px 24px",
                width: "100%",
                display: "flex",
                gap: 16,
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="h5"
                style={{
                  color: "#fff",
                  whiteSpace: "nowrap",
                  alignContent: "center",
                }}
                align="center"
              >
                {isId ? "Lowongan Pekerjaan" : "Job Vacancy"}
              </Typography>
              <div
                id="center1047"
                style={{ display: "flex", gap: 16, flexWrap: "wrap" }}
              >
                <input
                  type="text"
                  placeholder="Cari Pekerjaan"
                  onChange={(e) =>
                    setSearchState({
                      ...searchState,
                      job: e.target.value,
                    })
                  }
                  style={{
                    borderRadius: 4,
                    padding: "8px 24px",
                    outline: "none",
                  }}
                />
                <select
                  name="location"
                  id="location"
                  value={searchState.location}
                  onChange={(e) =>
                    setSearchState({ ...searchState, location: e.target.value })
                  }
                  style={{
                    borderRadius: 4,
                    padding: "8px 24px",
                    outline: "none",
                    appearance: "none",
                  }}
                >
                  <option value="">Semua lokasi</option>
                  {[
                    ...new Set(dataLokerState?.map(({ place }: any) => place)),
                  ].map((place: any) => (
                    <option value={place}>{place}</option>
                  ))}
                </select>
                <Button
                  style={{ color: "#fff", backgroundColor: "#424244" }}
                  size="small"
                  onClick={() => {
                    const job = searchState.job.toLowerCase();
                    const location = searchState.location;
                    const searchJob = dataLokerState.filter(
                      (row: any) =>
                        (row.title_id.toLowerCase().includes(job) ||
                          row.title_en.toLowerCase().includes(job) ||
                          row.sub_title_id.toLowerCase().includes(job) ||
                          row.sub_title_en.toLowerCase().includes(job)) &&
                        row.place.includes(location)
                    );
                    setSearchDataState(searchJob);
                  }}
                >
                  Cari
                </Button>
              </div>
            </div>
            {loadingState ? (
              <div style={{ width: "100%" }}>
                <Skeleton
                  variant="rect"
                  height={42}
                  style={{ marginBottom: 16 }}
                />
                <Skeleton
                  variant="rect"
                  height={42}
                  style={{ marginBottom: 16 }}
                />
                <Skeleton
                  variant="rect"
                  height={42}
                  style={{ marginBottom: 16 }}
                />
                <Skeleton variant="rect" height={42} />
              </div>
            ) : (
              formatDataLoker?.length === 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingTop: 32,
                  }}
                >
                  <Typography color="textSecondary">
                    {isId ? "Tidak ada Lowongan Pekerjaan" : "No Job Vacancies"}
                  </Typography>
                </div>
              )
            )}
            {formatDataLoker?.map(({ title_id, title_en, data }: any) => {
              const title = isId ? title_id : title_en;
              return (
                <React.Fragment key={title_id}>
                  <StyledItem
                    onClick={() =>
                      setActiveState(title === activeState ? "" : title)
                    }
                    active={title === activeState}
                  >
                    <StyledItemLeft>
                      {title === activeState ? (
                        <Remove style={{ color: "#424244" }} />
                      ) : (
                        <Add style={{ color: "#424244" }} />
                      )}
                      <Typography
                        variant="h6"
                        color="textPrimary"
                        style={{ marginLeft: "1rem" }}
                      >
                        {title}
                      </Typography>
                    </StyledItemLeft>
                    <div style={{ display: "flex" }}>
                      <Typography color="textPrimary">{data.length}</Typography>
                      <Typography style={{ marginLeft: ".5rem" }}>
                        {isId ? "Lowongan" : "Vacancies"}
                      </Typography>
                    </div>
                  </StyledItem>
                  {title === activeState &&
                    data.map((r: any, i: any) => (
                      <StyledCard
                        key={i}
                        onClick={() => {
                          setDetailDataLokerState(r);
                          setDetailLokerState(true);
                        }}
                      >
                        <StyledItemCard>
                          <StyledDescCard>
                            <Typography
                              color="textPrimary"
                              gutterBottom
                              style={{ fontWeight: 800 }}
                            >
                              {isId ? r.sub_title_id : r.sub_title_en}
                            </Typography>
                            <div
                              id="content"
                              style={{
                                color: "rgba(0, 0, 0, 0.54)",
                                lineHeight: "1.5em",
                                height: "3em",
                                overflow: "hidden",
                              }}
                            >
                              {parse(
                                isId
                                  ? r.content_id.substring(0, 200)
                                  : r.content_en.substring(0, 200)
                              )}
                            </div>
                          </StyledDescCard>
                          <StyledAddressCard>
                            <Typography color="textPrimary">
                              {r.place}
                            </Typography>
                            <Typography color="textSecondary">
                              {r.contract}
                            </Typography>
                          </StyledAddressCard>
                          <StyledNextCard>
                            <Icons.IconNext
                              width={20}
                              height={20}
                              fill="white"
                              secondFill="red"
                            />
                          </StyledNextCard>
                        </StyledItemCard>
                      </StyledCard>
                    ))}
                </React.Fragment>
              );
            })}
          </StyledItemList>
        </StyledContent>
      )}
    </>
  );
};

export default Loker;
